import React, {useRef, useEffect, useState} from "react";
import {makeStyles, Tab, Tabs, Box, Container, Typography, useTheme} from "@material-ui/core";
import {useBreakpoints} from "../../../hooks";
import PropTypes from "prop-types";
import HtmlComponentWrapper from "./HtmlComponentWrapper";
import {retrieveContentfulImage} from "../../../common/image";

const useStyles = makeStyles((theme) => ({
    tabs: {
        "& .MuiTab-wrapper": {
            padding: theme.spacing(8, 0, 5, 0),
            [theme.breakpoints.down("sm")]: {
                padding: theme.spacing(4, 1, 3, 1)
            },
        },
        "& button.MuiTab-root": {
            padding: 0,
            backgroundColor: "#F4F4ED",
            opacity: 1
        },
        "& button.MuiTab-root.Mui-selected": {
            backgroundColor: theme.palette.background.default
        },
        "& .MuiTabs-indicator": {
            backgroundColor: "unset"
        }
    },
    tabIndexBox: {
        width: theme.spacing(13.875),
        height: theme.spacing(13.875),
        [theme.breakpoints.down("sm")]: {
            width: theme.spacing(8.25),
            height: theme.spacing(8.25)
        }
    },
    tabIndex: {
        color: theme.palette.grey[800]
    },
    tabLabel: {
        color: theme.palette.primary[900],
        height: theme.spacing(9.5),
        maxWidth: theme.spacing(35),
        [theme.breakpoints.down("sm")]: {
            height: theme.spacing(6.625),
            maxWidth: theme.spacing(22.5)
        },
    }
}));

const TabMain = ({tabs, bgColor, anchorId}) => {

    const classes = useStyles();
    const theme = useTheme();
    const {isExtraSmallScreen, isSmallScreen} = useBreakpoints();

    const [tabIndex, setTabIndex] = useState(0);

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        location.hash = `${anchorId}-${(newValue + 1).toString()}`;
    };


    const tabsAnchor = useRef(null);

    useEffect(() => {
        if (tabsAnchor && location.hash.includes(`${anchorId}`)) {
            const whichTab = parseInt(location.hash.substring(location.hash.indexOf("-") + 1));
            if (tabs?.length - 1 >= whichTab - 1 && typeof whichTab === "number") {
                setTabIndex(whichTab - 1);
            }
        }
    }, [tabsAnchor]);

    return (
        <>
            <Box
                bgcolor={bgColor}
                ref={tabsAnchor}
            >
                <Container>
                    <Tabs
                        className={classes.tabs}
                        variant="fullWidth"
                        value={tabIndex}
                        onChange={handleTabChange}
                    >
                        {tabs?.map((tab, index) => {
                            return (
                                <Tab
                                    key={tab?.id}
                                    label={
                                        <>
                                            <Box
                                                className={classes.tabIndexBox}
                                                display="flex"
                                                justifyContent="center"
                                                alignItems="center"
                                                borderRadius="50%"
                                                bgcolor={!tab?.imageUrl ? theme.palette.primary[100] : undefined}
                                                mx="auto"
                                                mb={2}
                                            >
                                                {tab?.imageUrl ? (

                                                    <img
                                                        src={retrieveContentfulImage(tab?.imageUrl, {width: 80, height: 80, fit: "thumb"})}
                                                        alt={tab?.imageTitle}
                                                    />
                                                ) : (
                                                    <Typography
                                                        className={classes.tabIndex}
                                                        variant="h1"
                                                        component="span"
                                                    >
                                                        {index + 1}
                                                    </Typography>
                                                )}
                                            </Box>
                                            <Typography
                                                className={classes.tabLabel}
                                                variant={(!isExtraSmallScreen() && !isSmallScreen()) ? "h5" : "caption"}
                                                component="h2"
                                            >
                                                {tab?.title}
                                            </Typography>
                                        </>
                                    }
                                />
                            );
                        })}
                    </Tabs>
                </Container>
            </Box>
            {tabs?.map((tab, index) => tab?.elements &&
                (tabIndex === index &&
                    <Box
                        key={tab?.id}
                        bgcolor={tab?.bgColor}
                        pt={(isExtraSmallScreen() || isSmallScreen()) ? 6 : 13}
                    >
                        <HtmlComponentWrapper htmlComponents={tab.elements} />
                    </Box>
                )
            )}
        </>
    );
};

TabMain.propTypes = {
    tabs: PropTypes.array,
    bgColor: PropTypes.string,
    anchorId: PropTypes.string
};

export default TabMain;
